import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const OutlineEditIcon = forwardRef<SVGSVGElement, IconProps>(function OutlineEditIcon(
  { color = '', height = 10, width = 11, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.0205 8.23311C0.88858 7.63952 0.833333 6.86684 0.833333 5.85156C0.833333 4.83629 0.88858 4.0636 1.0205 3.47001C1.15174 2.87951 1.34786 2.51863 1.58551 2.28098C2.04887 1.81761 2.92543 1.57425 5 1.57425C7.07457 1.57425 7.95113 1.81761 8.41449 2.28098C8.65214 2.51863 8.84826 2.87951 8.9795 3.47001C9.11142 4.0636 9.16667 4.83629 9.16667 5.85156C9.16667 6.86684 9.11142 7.63952 8.9795 8.23311C8.84826 8.82362 8.65214 9.1845 8.41449 9.42214C7.95113 9.88551 7.07457 10.1289 5 10.1289C2.92543 10.1289 2.04887 9.88551 1.58551 9.42214C1.34786 9.1845 1.15174 8.82362 1.0205 8.23311ZM5 10.8516C0.8825 10.8516 0 9.96906 0 5.85156C0 1.73406 0.8825 0.851562 5 0.851562C9.1175 0.851562 10 1.73406 10 5.85156C10 9.96906 9.1175 10.8516 5 10.8516Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.06205 3.26057C5.38739 2.91941 5.9622 2.89578 6.31803 3.22005L7.65936 4.44243C7.98761 4.74158 8.00217 5.22464 7.70081 5.54065L4.93795 8.43788C4.78116 8.60229 4.54949 8.70727 4.29273 8.70822L3.03471 8.7129C2.5351 8.71475 2.19443 8.34781 2.16836 7.96395L2.08504 6.7369C2.07102 6.53039 2.1439 6.32064 2.29919 6.1578L5.06205 3.26057ZM5.71074 3.71521C5.70905 3.71651 5.70683 3.71841 5.70424 3.72113L5.1989 4.25104L6.57805 5.58404L7.05863 5.08009C7.09462 5.04234 7.0893 4.97127 7.05567 4.94062L5.71435 3.71824C5.71298 3.717 5.71177 3.71601 5.71074 3.71521ZM6.04105 6.14715L4.66191 4.81415L2.94137 6.61837C2.92804 6.63236 2.91457 6.65971 2.91693 6.69442L3.00025 7.92147C3.00247 7.95408 3.01688 7.97507 3.02765 7.98488C3.03083 7.98778 3.03317 7.98938 3.03463 7.99021L4.28557 7.98556C4.28739 7.98458 4.2911 7.98222 4.29577 7.97732L6.04105 6.14715Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
